import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import NumberFormat from "react-number-format";
import dayjs from "dayjs";
import {
  Button,
  Table,
  Spinner,
  Modal,
  Form,
  Row,
  Col,
  ButtonGroup,
  Alert,
} from "react-bootstrap";
import { HiSearchCircle } from "react-icons/hi";

import { ArrowRight, Check, CheckCircle } from "react-bootstrap-icons";
import { useUser, useFirestore, useFunctions } from "reactfire";
import { httpsCallable } from "firebase/functions";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  getDoc,
  addDoc,
  setDoc,
  doc,
  orderBy,
  limit,
  collectionGroup,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import CryptoJS from "crypto-js";
import StockCardSummaryRecon from "../helpers/StockCardSummaryRecon";
import FirebaseStoragePhotosComponent from "./FirebaseStoragePhotoComponent";

var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

const laneBase = require("../../assets/json/lane_base_d1_vic.json");
const laneBaseTmp = [...laneBase.lanes];
const externalYardOptions = laneBaseTmp?.filter(
  (y) => y.activeInRWC === 1 || false
);

const MagicYardLocation = "MagicWash";

const ReconVehicleDetailModalRWCClock = ({
  data,
  show,
  handleClose,
  createNew = false,
  stateFilter,
  buyingFilterUserRoles,
}) => {
  const [loading, setLoading] = useState(false);
  const [localData, setLocalData] = useState(data);

  const [saving, setSaving] = useState(false);
  const [refreshToggle, setRefreshToggle] = useState(false);

  const [numberOfKeys, setNumberOfKeys] = useState(null);
  const [serviceHistory, setServiceHistory] = useState(null);

  const [existingTimesheetForm, setExistingTimesheetForm] = useState([]);
  const [clockInSatus, setClockInStatus] = useState(false);
  const [clockOutStatus, setClockOutStatus] = useState(false);
  const [currentJobStatus, setCurrentJobStatus] = useState(false);
  const [currentJobStatusText, setCurrentJobStatusText] = useState(false);

  const [vehicleHash, setVehicleHash] = useState("");

  const [nextYardLocation, setNextYardLocation] = useState(MagicYardLocation);
  const [yardLocationExpectedReturnDate, setYardLocationExpectedReturnDate] =
    useState(null);

  //   Hooks
  const firestore = useFirestore();
  const user = useUser();
  const functions = useFunctions();

  const handleSaveRWCClockIn = async () => {
    // if > 1 form exists, show confirmation modal
    if (existingTimesheetForm.length > 0) {
      toast.error("Please clock out of existing form before clocking in");
      return;
    }
    setSaving(true);

    console.log(data);
    console.log(user);

    const payload = {
      createdBy: user?.data?.displayName,
      createdByEmail: user?.data?.email,
      createdByPhone: user?.data?.phoneNumber,
      createdById: user?.data?.uid,
      createdAt: dayjs().unix(),
      clockIn: dayjs().unix(),
      clockOut: null,
      vin: data?.veh?.VEHVIN,
      stockNumber: data?.veh?.VEHStockNumber,
      branchId: data?.veh?.BranchId,
      branchName: data?.veh?.Branch,
      make: data?.veh?.VEHMake,
      model: data?.veh?.VEHmodel,
      year: data?.veh?.VEHModelYear,
      yard: data?.veh?.VEHYard,
      odometer: data?.veh?.VEHOdo,
      type: "RWC-ClockIn",
      typeId: 1,
      jobClosed: false,
    };

    console.log(payload);
    // Create an md5 hash of VEHStockNumber and VEHVIN
    const stockVin = `${data?.veh.VEHStockNumber}${data?.veh.VEHVIN}`;
    const hash = CryptoJS.MD5(stockVin).toString();
    console.log(stockVin, hash);

    const arrivalChecklistRef = await addDoc(
      collection(firestore, "reconditioning-process", hash, "recon-form-rwc"),
      payload
    )
      .then((r) => {
        toast.success("Saved form");
        setRefreshToggle((prev) => !prev);
      })
      .catch((e) => {
        toast.error("Error saving form");
        console.log(e);
      });

    // @TODO - UNCOMMENT THIS AFTER CHANGING TO RECON BRANCH
    // await pushToNextYardLocation();
    setSaving(false);
  };

  const handleSaveRWCClockOut = async () => {
    // if > 1 form exists, show confirmation modal
    if (existingTimesheetForm.length === 0) {
      toast.error("Please clock in before closing job");
      return;
    }
    setSaving(true);

    if (
      yardLocationExpectedReturnDate === null ||
      yardLocationExpectedReturnDate === undefined ||
      yardLocationExpectedReturnDate === ""
    ) {
      toast.error("Please select an expected return date for the vehicle");
      setSaving(false);
      return;
    }

    console.log(data);
    console.log(user);

    const payload = {
      updatedBy: user?.data?.displayName,
      updatedByEmail: user?.data?.email,
      updatedByPhone: user?.data?.phoneNumber,
      updatedById: user?.data?.uid,
      updatedAt: dayjs().unix(),
      clockOut: dayjs().unix(),
      jobClosed: true,
      jobClosedBy: user?.data?.displayName,
      jobClosedByEmail: user?.data?.email,
      jobClosedByPhone: user?.data?.phoneNumber,
      jobClosedById: user?.data?.uid,
      jobClosedAt: dayjs().unix(),
      nextYardLocation: nextYardLocation,
      nextYardLocationExpectedReturnDate: yardLocationExpectedReturnDate,
    };

    console.log(payload);
    // Create an md5 hash of VEHStockNumber and VEHVIN
    const stockVin = `${data?.veh.VEHStockNumber}${data?.veh.VEHVIN}`;
    const hash = CryptoJS.MD5(stockVin).toString();
    console.log(stockVin, hash);

    const arrivalChecklistRef = doc(
      firestore,
      "reconditioning-process",
      hash,
      "recon-form-rwc",
      existingTimesheetForm[0].id
    );

    await updateDoc(arrivalChecklistRef, payload, {
      merge: true,
    })
      .then((r) => {
        toast.success("Updated form");
        setRefreshToggle((prev) => !prev);
      })
      .catch((e) => {
        toast.error("Error saving form");
        console.log(e);
      });

    // @TODO - UNCOMMENT THIS AFTER CHANGING TO RECON BRANCH
    await pushToNextYardLocation(nextYardLocation);
    setSaving(false);
  };

  const pushToNextYardLocation = async (nextYardLocation) => {
    const yardLocation = nextYardLocation;
    const yardLocationComments = `Changed by ${user.data.displayName} from ${data?.veh?.VEHYard} to ${yardLocation}`;

    const payload = {
      selectedVehicle: data?.veh,
      comments: yardLocationComments,
      createdAt: dayjs().format("YYYY-MM-DD"),
      createdBy: user.data.displayName,
      VEHStockNumber: data?.veh?.VEHStockNumber,
      VIN: data?.veh?.VEHVIN,
      originalBranch: data?.veh?.Branch,
      yardLocation: yardLocation,
      EclipseDBName: data?.veh?.db,
      EclipseBranchID: data?.veh?.BranchId,

      actioned: false,
      actionStatus: null,
      actionedTimestamp: null,
      action: "GENERAL_YARD_LOG_UPDATE",
    };

    // Callable function
    const yardChangeLogRequestD1VIC = httpsCallable(
      functions,
      "yardChangeLogRequestD1VIC"
    );

    await yardChangeLogRequestD1VIC({
      yardChangeData: payload,
      selectedVehicle: data?.veh,
    })
      .then((r) => {
        console.log(r);
        if (r.data.status === "success") {
          toast.success("Yard location update queued");
          toast.success(
            "Yard log should update to Inspection in Eclipse in 5 minutes"
          );
        } else {
          toast.error("Yard location update failed");
        }
      })
      .catch((e) => {
        toast.error(e.message);
      });
  };

  // On mount load any existing arrival forms
  useEffect(() => {
    const stockVin = `${data?.veh.VEHStockNumber}${data?.veh.VEHVIN}`;
    const hash = CryptoJS.MD5(stockVin).toString();
    setVehicleHash(hash);
    console.log(stockVin, hash);
    const arrivalChecklistRef = collection(
      firestore,
      "reconditioning-process",
      hash,
      "recon-form-rwc"
    );
    const q = query(arrivalChecklistRef, orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const arrivalForms = [];
      querySnapshot.forEach((doc) => {
        arrivalForms.push({ id: doc.id, ...doc.data() });
      });
      console.log(arrivalForms);
      setExistingTimesheetForm(arrivalForms);
    });
    return () => {
      unsubscribe();
    };
  }, [JSON.stringify(data), refreshToggle]);

  useEffect(() => {
    // Refresh the data when the modal state changes or refreshToggle changes
    setLocalData(data);
    setNumberOfKeys(null);
    setServiceHistory(null);
    setExistingTimesheetForm([]);
  }, [show, refreshToggle]);

  return (
    <Modal show={show} size="lg" onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <h5>
            {data?.veh?.VEHStockNumber} -{" "}
            {`${data?.veh?.VEHModelYear} ${data?.veh?.VEHMake} ${data?.veh?.VEHmodel}`}
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <h4>RWC checklist</h4>
            {existingTimesheetForm.length > 0 && (
              <div>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>Started By</th>
                      <th>Started job</th>
                      <th>Finished By</th>
                      <th>Finished job</th>
                      {/* <th>Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    <tr key={existingTimesheetForm[0].id}>
                      <td>{existingTimesheetForm[0].createdBy}</td>
                      <td>
                        {" "}
                        {dayjs
                          .unix(existingTimesheetForm[0].clockIn)
                          .format("DD/MM/YYYY HH:mm")}
                      </td>
                      <td>
                        {existingTimesheetForm[0].jobClosed &&
                          existingTimesheetForm[0].jobClosedBy}
                      </td>
                      <td>
                        {existingTimesheetForm[0].clockOut !== null && (
                          <span>
                            {" "}
                            {dayjs
                              .unix(existingTimesheetForm[0].clockOut)
                              .format("DD/MM/YYYY HH:mm")}
                            <CheckCircle
                              style={{
                                color: "green",
                                marginLeft: 5,
                                fontSize: 20,
                              }}
                            />
                          </span>
                        )}
                      </td>
                      {/* <td>
                            <Button
                              variant="primary"
                              onClick={() => {
                                // setLocalData(form);
                                // setShowArrivalForm(true);
                              }}
                            >
                              View
                            </Button>
                          </td> */}
                    </tr>
                  </tbody>
                </Table>
                <Row>
                  <Col>
                    {/* Options for externalYardLocations */}
                    <Form.Group
                      controlId="form-external-yard-location"
                      style={{ marginTop: 10 }}
                    >
                      <Form.Label>
                        Where are you sending this car next?
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="externalYardLocation"
                        onChange={(e) => {
                          setNextYardLocation(e.target.value);
                        }}
                        // defaultChecked={MagicYardLocation}
                        defaultValue={MagicYardLocation}
                      >
                        {externalYardOptions?.map((option, index) => {
                          return (
                            <option key={index} value={option.id}>
                              {option.title}
                            </option>
                          );
                        })}
                      </Form.Control>
                    </Form.Group>
                    {/* <pre>{JSON.stringify(externalYardOptions, null, 2)}</pre> */}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    {/* Options for externalYardLocations */}
                    <Form.Group
                      controlId="form-external-yard-location-return-date"
                      style={{ marginTop: 10 }}
                    >
                      <Form.Label>When do you expect it back?</Form.Label>
                      <Form.Control
                        as="input"
                        type="date"
                        name="externalYardLocationExpectedReturnDate"
                        onChange={(e) => {
                          // Convert to UNIX timestamp
                          const expectedReturnDate = dayjs(
                            e.target.value
                          ).unix();
                          setYardLocationExpectedReturnDate(expectedReturnDate);
                        }}
                      />
                    </Form.Group>
                    {/* <pre>{JSON.stringify(externalYardOptions, null, 2)}</pre> */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      variant="warning"
                      onClick={handleSaveRWCClockOut}
                      disabled={saving || existingTimesheetForm[0].jobClosed}
                    >
                      {saving ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          Saving...
                        </>
                      ) : (
                        " Close job and send to detailing"
                      )}
                    </Button>
                    {/* {JSON.stringify(existingTimesheetForm[0])} */}
                  </Col>
                </Row>
              </div>
            )}
          </Col>
        </Row>
        {existingTimesheetForm.length === 0 && (
          <Row>
            <Col>
              <Button
                variant="primary"
                onClick={handleSaveRWCClockIn}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Saving...
                  </>
                ) : (
                  "Pick up and start job"
                )}
              </Button>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <StockCardSummaryRecon
          veh={data?.veh}
          yardLogs={data?.veh?.yardLogs || []}
        />
        {/* {JSON.stringify(data, null, 2)} */}
        <Button onClick={handleClose} variant="secondary">
          Close
        </Button>
        <FirebaseStoragePhotosComponent vehicleId={vehicleHash} />
      </Modal.Footer>
    </Modal>
  );
};

export default ReconVehicleDetailModalRWCClock;
